import { useOutletContext } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import PricesView from "../views/PricesView/PricesView";

export default function Prices() {
	const { organization } = useOutletContext();

	const hasRight = useHasRight();

	if (!hasRight("prices.view")) {
		return <Unauthorized />;
	}

	return <PricesView producerId={organization.id} />;
}
